import { gql } from '@apollo/client';
import type { Bookmark } from 'types/Bookmark';
import type {AdminError} from 'graphql/admin';
import {BOOKMARK_FRAGMENT} from './AdminBookmarkFragments';

export const GET_BOOKMARKS_QUERY = gql`
  query GetBookmarks($getBookmarksInput: GetBookmarksInput!) {
    getBookmarks(getBookmarksInput: $getBookmarksInput) {
      __typename
      ... on GetBookmarksErrorOutput {
        errorReason
      }
      ... on GetBookmarksOutput {
        bookmarks {
          ...Bookmark
        }
      }
    }
  }
  ${BOOKMARK_FRAGMENT}
`;

export type GetBookmarksOutput = {
  getBookmarks: {
    __typename: string;
    errorReason: AdminError;
    bookmarks: Bookmark[];
  };
};